import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { ProductRowStyles } from '@stories/Elements/Cards/ProductRow/ProductRow.styles';
import { m } from 'framer-motion';
import styled from 'styled-components';

const Container = styled.div``;

const IncludedProducts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const IncludedProductsHeading = styled.div`
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  span {
    ${fonts.helvetica['87-heavy-condensed']};
    font-size: 16px;
    color: ${brand.grey['35']};

    &:nth-child(1) {
      flex: 0 0 48px;

      @media ${from(Device.TabletLarge)} {
        flex: 0 0 64px;
      }
    }

    &:nth-child(2) {
      flex: 1 1 100%;
    }

    &:nth-child(3) {
      flex: 0 1 44px;
      text-align: center;

      @media ${from(Device.TabletLarge)} {
        flex: 0 1 105px;
      }
    }
  }
`;

const CollapsibleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const CollapsibleHeader = styled.div`
  padding: 24px;
  background-color: ${brand.grey[95]};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  > span {
    display: flex;
    align-items: center;
    gap: 8px;

    ${fonts.helvetica['97-black-condensed']};
    font-size: 18px;
    line-height: 18px;
    color: ${brand.black};
    text-transform: uppercase;

    > span:last-of-type {
      color: ${brand.grey[35]};
    }
  }

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
  }
`;

const CollapsibleContent = styled(m.div).attrs<{ 'data-active': boolean }>((props) => ({
  initial: { height: 0 },
  animate: { height: props['data-active'] === true ? 'auto' : 0 },
  transition: { duration: 0.2, ease: 'easeInOut' },
}))<{ 'data-active': boolean }>`
  overflow: hidden;
`;

const CollapsibleContentInner = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${IncludedProductsHeading} {
    min-height: 24px;
    align-items: flex-end;
  }

  ${ProductRowStyles.Media} {
    flex: 0 0 64px;

    img {
      width: 64px;
      height: 64px;
    }
  }
`;

export const ProductBreakdownAccordionStyles = {
  Container,
  IncludedProducts,
  IncludedProductsHeading,
  CollapsibleContainer,
  CollapsibleHeader,
  CollapsibleContent,
  CollapsibleContentInner,
};
